module.exports = __webpack_public_path__ + "img/sync-sazito.31fb8f3c.png";